module.exports = __webpack_public_path__ + "../resources/img/ic_cloudy_weather.a1326e70.svg";